// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1dMEm","requiredAsterisk":"Info_requiredAsterisk__2MF8H"};